import axios from "axios";

const getUserIp = async () => {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error getting IP address:", error);
    return null;
  }
};

export default getUserIp;
